import i18n from '../i18n';

/** Значения совпадают с API (GuardianRelationships). */
export function getGuardianRelationships() {
    return [
        { value: 'father', label: i18n.t('guardianLink:relationships.father') },
        { value: 'mother', label: i18n.t('guardianLink:relationships.mother') },
        { value: 'grandmother', label: i18n.t('guardianLink:relationships.grandmother') },
        { value: 'grandfather', label: i18n.t('guardianLink:relationships.grandfather') },
        { value: 'other', label: i18n.t('guardianLink:relationships.other') }
    ];
}

export const GUARDIAN_RELATIONSHIPS = getGuardianRelationships();

export const DEFAULT_GUARDIAN_RELATIONSHIP = 'mother';

export function guardianRelationshipLabel(value) {
    return getGuardianRelationships().find(r => r.value === value)?.label
        || (value === 'parent' ? i18n.t('guardianLink:relationships.parent')
            : value === 'guardian' ? i18n.t('guardianLink:relationships.guardian')
                : i18n.t('guardianLink:relationships.other'));
}
